export default {
    title: `Derrière cet arbre, toute une forêt`,

    subTitleMC: `Patrick Folléa, directeur de Société Générale Private Banking`,
    subTitleFR: `Mathieu Vedrenne, directeur de Société Générale Private Banking France`,
    subTitleLU: `Olivier Lecler, directeur de Société Générale Private Banking Luxembourg`,
    subTitleCH: `Franck Bonin, directeur de Société Générale Private Banking Suisse`,

    mainContent: `
    <p>
       L'arbre qui tombe fait plus de bruit que la forêt qui pousse. Méditons, à l’heure où la crise sanitaire s’installe dans la durée, la sagesse de ce proverbe africain. Les difficultés auxquelles nous sommes confrontés, pour importantes qu'elles soient, ne doivent pas occulter les transformations positives du monde qui sont à l’œuvre et que la crise même, parfois, accélère. Le développement durable et responsable quitte l'ordre du discours pour entrer dans les faits. Et peu à peu, jour après jour, la prise de conscience débouche sur l’action.
    </p>
    <p>
        S’il était besoin d’une illustration de ce qui précède, on la trouverait dans ce magazine. La philanthropie, l’e-santé, l’énergie : dans tous ces domaines, sans faire de bruit, la forêt pousse. On découvrira aussi comment des photographes passionnés capturent le silence du monde ; comment une galerie d'Art inspirée découvre les artistes de demain ; et pour finir, après le long silence imposé par la pandémie, comment les musiciens retrouvent progressivement leur public et le chemin de la créativité.
    </p>
    <p>
        Je vous souhaite, avec l’ensemble des équipes de Société Générale Private Banking, une heureuse année 2021 et une excellente lecture de ce nouveau magazine.
    </p>`,

};

